<template>
    <input
        ref="flatpickr-input"
        class="form-control bg-white" />
</template>

<script>
    import {Swedish} from 'flatpickr/dist/l10n/sv.js';
    import flatpickr from 'flatpickr';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        props: {
            modelValue: {
                type: String,
                default: ''
            },
            config: {
                type: Object,
             }
        },

        watch: {
            modelValue(value) {
                this.flatpickr.setDate(this.modelValue);
            },

            config: {
                deep: true,
                handler (config) {
                    if (!this.flatpickr) {
                        return;
                    }

                    for (const prop in config) {
                        this.flatpickr.set(prop, config[prop]);
                    }
                }
            }
        },

        data () {
            return {
                flatpickr: null,
            }
        },

        mounted () {
            const defaultConfig = {
                locale: Swedish,
                onChange: (selectedDates, dateStr, instance) => {
                    this.$emit('update:modelValue', dateStr);
                },
            };

            this.flatpickr = flatpickr(this.$refs['flatpickr-input'], {...defaultConfig, ...this.config});
        },

        beforeUnmount () {
            this.flatpickr.destroy();
            this.flatpickr = null;
        }
    }
</script>
